/**
 * Shared amplifier-name lookup, cached via TanStack Query.
 *
 * Extracted from SocialCalendarView.tsx during FEAT-062 review — that file
 * and AmplificationsPanel.tsx both look up amplifier display names by id,
 * and had drifted into two copies of the same hook with different cache
 * policies (one query key, two behaviors). This is the single source now.
 */
import { useApiQuery } from "@/lib/api";

export interface AmplifierLookupRow {
  id: number;
  displayName?: string;
  display_name?: string;
  slug: string;
}

export function useAmplifierLookup(id: number | null | undefined) {
  const { data } = useApiQuery<AmplifierLookupRow>(
    ["amplifier", id ?? 0],
    `/amplifiers/${id ?? 0}`,
    {
      // FEAT-095 / S-401 retirement — a social_calendar row created after the
      // amplifier retirement carries account_id, not amplifier_id, so callers
      // pass null/undefined here for those rows. Without this gate that would
      // still fire a doomed /amplifiers/0 request on every such row.
      enabled: id != null,
      // Amplifiers change rarely. 5 min is generous.
      staleTime: 5 * 60_000,
      retry: false,
    }
  );
  return data;
}

export function amplifierDisplayName(amp: AmplifierLookupRow | undefined, id: number): string {
  return amp?.displayName ?? amp?.display_name ?? `Amplifier #${id}`;
}
